module.exports = __webpack_public_path__ + "img/TBWTTNL_render_special-cards.56601553.png";